import React, {Component} from 'react';
import {Table} from 'antd';

class GroupGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      packageData: [],
      pagination: {
        hideOnSinglePage: true
      }
    };
  }
  componentWillMount() {
    this.setState({packageData: this.props.goodsData});
  }
  componentWillReceiveProps(props) {
    this.setState({packageData: props.goodsData});
  }
  render() {
    const columns = [
      {
        title: '商品',
        key: 'goods',
        dataIndex: '',
        render: (record) => (
          <span>
            <img src={record.goods_picture} className="img-ico" />
            {record.goods_name}
          </span>
        )
      },
      {
        title: '商品单价',
        key: 'sale_price',
        dataIndex: 'sale_price'
      },
      {
        title: '数量',
        key: 'goods_amount',
        dataIndex: 'goods_amount'
      }
    ];
    const {
      packageData,
      pagination
    } = this.state;
    return (
      <div className="package-blocks package-group-goods" style={{height: '400px', overflow: 'auto'}}>
        <Table
          columns={columns}
          dataSource={packageData}
          pagination={pagination}
          className="table-blocks"
          rowKey={record => record.id}
          size="small"
        />
      </div>
    );
  }
}
export default GroupGoods;



// WEBPACK FOOTER //
// ./src/containers/backEnd/packageMangement/groupgoods.jsx